import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { EntityIdObject } from "../../../common/types";
import { CalcType } from "../enums";
import { RealtyCalc, RealtyGen } from "./realty/types";
import { TravelCalc, TravelGen } from "./travel/types";
import { CalcAttachment, CalcResponse, CalcResultData, GenResponse, Offer } from "./types";
import { VehicleCalc, VehicleGen } from "./vehicle/types";

const CALCULATE = ApiRequestAdapter.create("/calculators/calculate", HttpMethod.POST);
const GENERATE = ApiRequestAdapter.create("/calculators/generate", HttpMethod.POST);
const GENERATE_OFFER = ApiRequestAdapter.create("/calculators/offer", HttpMethod.POST);
const SEND_OFFER = ApiRequestAdapter.create("/calculators/offer/send", HttpMethod.POST);
const UPLOAD_CALC_ATTACHMENTS = ApiRequestAdapter.create("/calculators/attachments", HttpMethod.POST);
const DOWNLOAD_CARD_READER = ApiRequestAdapter.create("/card-reader/download", HttpMethod.GET);
const DOWNLOAD_CALC_RESULT_ATTACHMENT = ApiRequestAdapter.create("/calculators/attachments/{0}", HttpMethod.GET);

export const calculatorsApi = {
  calculate: <T extends CalcResultData = CalcResultData, U extends CalcType = CalcType>(
    request: TravelCalc | RealtyCalc | VehicleCalc,
  ): AxiosPromise<CalcResponse<T, U>> => {
    return apiService.post(CALCULATE.url, request);
  },
  generate: (request: TravelGen | RealtyGen | VehicleGen): AxiosPromise<GenResponse> => {
    return apiService.post(GENERATE.url, request);
  },
  generateOffer: <T extends TravelCalc | RealtyCalc | VehicleCalc, U extends CalcResultData>(
    request: Offer<T, U>,
  ): AxiosPromise<Blob> => {
    return apiService.post(GENERATE_OFFER.url, request, { responseType: "blob" });
  },
  sendOffer: <T extends TravelCalc | RealtyCalc | VehicleCalc, U extends CalcResultData>(
    request: Offer<T, U>,
  ): AxiosPromise => {
    return apiService.post(SEND_OFFER.url, request);
  },
  uploadCalcAttachments: (request: FormData): AxiosPromise<CalcAttachment[]> => {
    return apiService.post(UPLOAD_CALC_ATTACHMENTS.url, request);
  },
  downloadCardReader: (): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_CARD_READER.url, { responseType: "blob" });
  },
  downloadCalcResultAttachment: (request: EntityIdObject): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_CALC_RESULT_ATTACHMENT.getParametrizedUrl(request.id), { responseType: "blob" });
  },
};
